import { render, staticRenderFns } from "./facturasPendientes.vue?vue&type=template&id=240d8328&scoped=true"
import script from "./facturasPendientes.vue?vue&type=script&lang=js"
export * from "./facturasPendientes.vue?vue&type=script&lang=js"
import style0 from "./facturasPendientes.vue?vue&type=style&index=0&id=240d8328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d8328",
  null
  
)

export default component.exports